import { onlyNumbers } from '@brazilian-utils/helper-only-numbers';
import { generateChecksum } from '@brazilian-utils/helper-generate-checksum';

var RESERVED_ENTRIES = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];
var VERIFICATION_INDEXES = [9, 10];

function isFormatValid(taxId) {
  return /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/.test(taxId);
}

function isReserved(taxId) {
  return RESERVED_ENTRIES.indexOf(taxId) >= 0;
}

function isChecksumValid(taxId) {
  return VERIFICATION_INDEXES.every(function (index) {
    var mod = generateChecksum(taxId.slice(0, index).split('').reduce(function (a, b) {
      return a + b;
    }, ''), index + 1) % 11;
    return taxId[index] === String(mod < 2 ? 0 : 11 - mod);
  });
}

function isValidCpf(cpf) {
  if (!cpf) return false;
  var numericCPF = onlyNumbers(cpf);
  return isFormatValid(cpf) && !isReserved(numericCPF) && isChecksumValid(numericCPF);
}

export { isValidCpf };
//# sourceMappingURL=is-valid-cpf.esm.js.map
